export default "__VITE_ASSET__k7GuZ2mz__"